// extracted by mini-css-extract-plugin
export default {"submenu":"Submenu_submenu__oXoEy","hidden":"Submenu_hidden__rA06C","submenuArrow":"Submenu_submenuArrow__Z84U8","icon":"Submenu_icon__QL2aK"};